import { ContactI } from '@interfaces/contact.interface';
import { BlacklistTypeE } from '@modules/blacklist/enums/blacklist-type.enum';
import { BlacklistUseE } from '@modules/blacklist/enums/blacklist-use.enum';

export function isBlacklisted(contact: ContactI, type: BlacklistTypeE, use: BlacklistUseE) {
  if (!contact?.blackList) {
    return false;
  }

  return (
    (contact.blackList.type === type || contact.blackList.type === BlacklistTypeE.INCOMING_OUTGOING) &&
    (!contact.blackList.use?.length || contact.blackList.use.includes(use))
  );
}
